"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueRequestFinished = exports.uniqueRequest = void 0;
/**
 * A singleton service that keeps track of request identified by a "unique" id. If any
 * part of the app tries to perform a request that uses the same unique identifier, the
 * previous request will be cancelled.
 *
 * Why is this a singleton and not a slice in redux?
 * We actually need 2 things to both keep track and cancel a specific request: the identifier
 * itself and the CancelTokenSource registerd to said request. Since CancelTokenSource is
 * not a "serializable" javascript object, it cannot be stored inside redux as stated in
 * the official documentation. More info can be found here:
 *
 * https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state
 */
var CancellableRequestTracker = /** @class */ (function () {
    // We want this constructor to be private.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function CancellableRequestTracker() {
        this.registeredRequests = {};
        // empty constructor
    }
    /**
     * Returns the shared instance
     */
    CancellableRequestTracker.getInstance = function () {
        if (!CancellableRequestTracker.instance) {
            CancellableRequestTracker.instance = new CancellableRequestTracker();
        }
        return CancellableRequestTracker.instance;
    };
    CancellableRequestTracker.prototype.ensureUniqueRequest = function (uniqueKey, newCancelToken) {
        // Ignore empty unique keys
        if (uniqueKey === '') {
            return;
        }
        if (Object.keys(this.registeredRequests).includes(uniqueKey)) {
            var cancelToken = this.registeredRequests[uniqueKey];
            cancelToken.cancel();
            delete this.registeredRequests[uniqueKey];
        }
        this.registeredRequests[uniqueKey] = newCancelToken;
    };
    CancellableRequestTracker.prototype.requestFinished = function (uniqueKey) {
        if (Object.keys(this.registeredRequests).includes(uniqueKey)) {
            delete this.registeredRequests[uniqueKey];
        }
    };
    return CancellableRequestTracker;
}());
exports.default = CancellableRequestTracker;
/**
 * To mitigate the issue that arises in tests where a singleton is impossible to mock, all
 * external transactions will be made through these methods (which CAN be mocked). Consider
 * them as the "public" interface of the CancellableRequestTracker.
 */
/**
 * Registers a new unique request, and cancels any previous request sharing that token
 *
 * @param uniqueKey - The unique request identifier
 * @param newCancelToken - A reference to the cancel token registered in axios
 */
function uniqueRequest(uniqueKey, newCancelToken) {
    CancellableRequestTracker.getInstance().ensureUniqueRequest(uniqueKey, newCancelToken);
}
exports.uniqueRequest = uniqueRequest;
/**
 * Unregisters the provided unique identifier from the "unique" request list.
 *
 * @param uniqueKey - The unique request identifier
 */
function uniqueRequestFinished(uniqueKey) {
    CancellableRequestTracker.getInstance().requestFinished(uniqueKey);
}
exports.uniqueRequestFinished = uniqueRequestFinished;
//# sourceMappingURL=CancellableRequestTracker.js.map